import { FaWhatsapp } from "react-icons/fa";
import { Action } from "../../../../components/ui/Action";
import { AgendaInteligenteController } from '../../../../services/controllers/agendaInteligente'
import { useAgendaInteligente } from '../../../../store/agendaInteligente/useAgendaInteligente'


export function AppointmentActions({ appointment }) {
  const CAgendaInteligente = AgendaInteligenteController()
  const done = useAgendaInteligente(st => st.data.contactDone[appointment.appointmentId] ?? false)

  return (
    <div className='flex items-center justify-end gap-2 w-full'>
      <Action.Root
        status="success"
        type="button"
        title="Enviar WhatsApp"
        name={`send-message-${appointment.appointmentId}`}
        disabled={done}
        style={{ width: 32, height: 32, minWidth: 32, maxWidth: 32, padding: 0, }}
        onClick={() => !done && CAgendaInteligente.openWhatsApp(appointment.appointmentId)}
      >
        <Action.Icon icon={FaWhatsapp} size={16} />
      </Action.Root>
    </div>
  )
}
